module.exports = __webpack_public_path__ + "img/enston-address.dfae067e.png";